import DDadosBase from "@common/components/ddados/ddados.base";
import Field from "@common/components/validation/field.validation";
import React, { Fragment } from "react";
import autoBind from "react-autobind";

class DDadosComponent extends DDadosBase {
	constructor(props) {
		super(props);
		autoBind(this);
	}

	onChange(field, form) {
		return e => {
			form.setFieldValue(this.props.name, !field.value);
			this.dispatchChanges(!field.value, form, field);
		};
	}

	renderComponent() {
		const { props } = this;
		const { Label, Desabilitado } = props;

		return (
			<Field {...props}>
				{({ value, onChange }) => {
					return (
						<Fragment>
							
							{Label && <label>{props.Label}</label>}
							<div className="onoffswitch dominio-switch">
								<input
									className="onoffswitch-checkbox"
									type="checkbox"
									checked={value || false}
									disabled={Desabilitado}
									onChange={Desabilitado ? undefined : e => {
										onChange(!value);
									}}
								/>
								<label className="onoffswitch-label" onClick={Desabilitado ? undefined : e => { 
									onChange(!value);
								}}>
									<span className="onoffswitch-inner"></span>
									<span className="onoffswitch-switch"></span>
								</label>
							</div>
						</Fragment>
					)
				}}
			</Field>
		);
	}

	renderView() {
		return (
			<Field {...this.props}>
				{field => {
					return (
						<div>
							{this.props.Label && <label>{this.props.Label}</label>}
							<span>
								<label className='form-control'>{field.value ? "Ativada" : "Desativada"}</label>
							</span>
						</div>
					);
				}}
			</Field>
		);
	}

	renderHeader() {
		return (
			<div>
				<Field {...this.props}>
					{field => {
						return (
							<div>
								{this.props.Label && <label style={{ fontWeight: 'bold' }}>{this.props.Label}</label>}
								<label>{field.value ? "Ativada" : "Desativada"}</label>
							</div>
						);
					}}
				</Field>
			</div>
		);
	}
}

export default DDadosComponent;